import { useContext } from "react";

import AuthContext from "context/auth/authContext";
import { DEVICE_COLUMNS } from "shared/constants/columns";
import { usePermissions } from "shared/hooks/usePermissions";
import {
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS
} from "shared/types/enums";

import DeviceStatistics from "../DeviceStatistics";
import MainContainer from "../MainContainer";
import Table from "../Table";

const Devices = () => {
    const { isSupportUser } = useContext(AuthContext);
    const { isReadDeviceNotAllowed } = usePermissions();

    return (
        <>
            <MainContainer>
                <Table
                    name={TABLE_NAMES.Devices}
                    nameForFilters={TABLE_NAMES_WITH_FILTERS.Devices}
                    hasNoPermissionToRead={isReadDeviceNotAllowed}
                    initialColumns={DEVICE_COLUMNS}
                    idType={ID_TYPE.Imei}
                    hasActionBar
                    hasDetails
                />
            </MainContainer>

            {!isSupportUser && <DeviceStatistics />}
        </>
    );
};

export default Devices;
